import OrdersTimeStats from "./OrdersTimeStats";

export default OrdersTimeStats;